export function removeHighlightCat(id, target) {
  let cat_row = document.getElementById('cat_'+id);
  if (cat_row != null)
    cat_row.className = cat_row.className.replace(' green lighten-4','');
}

export function removeCat(id, target) {
  removeHighlightCat(id, target);
  if (target.value !== "")
  {
    if ( parseInt(target.value) === parseInt(id) )
    {
      target.value = "";
    }
  }
}

export function subInit() {

  let subs = document.querySelectorAll('.asdcats');
  if (!subs) {
    console.log('No subs to init');
    return;
  }
  subs.forEach( sub => {
    let selected_json = sub.getAttribute('data-selected' );
    let selected;
    try {
      selected = JSON.parse(selected_json);
    }
    catch (e) {
      console.log("Error while analyzing asdcats selected values");
    }

    if (!Array.isArray(selected) || selected.length === 0) {
      console.log('Cannot proceed: ', selected);
      return;
    }

    console.log("selected cats", selected);

    selected.forEach( sel_cat_id => {

      if (sel_cat_id === 0) {
        return;
      }

      let el = document.getElementById('cat_'+sel_cat_id);
      if (el.parentNode.classList.contains('asdcats'))
        return;
      if ( ! el.parentNode.classList.contains('open') )
        el.parentNode.classList.add('open');
    });
  });

}
